import { ZoneId } from "@js-joda/core";
import React from "react";
import { DATE_FORMATTER_SECONDS } from "utils/constants";
import { fmtDatetime } from "utils/time-utils";

interface DiffRowProps {
  label: string;
  value: number;
  unit: string;
  timestamp: string;
  diffDecimalPlaces?: number;
  tz: ZoneId;
}
const DiffRow = ({ label, value, unit, timestamp, diffDecimalPlaces, tz }: DiffRowProps) => {
  return (
    <div className="flex flex-row justify-content-between gap-2">
      <b>{label}:</b>
      <span>
        {value.toFixed(diffDecimalPlaces)} {unit}, {fmtDatetime(timestamp, tz, DATE_FORMATTER_SECONDS)}
      </span>
    </div>
  );
};

export default DiffRow;
